<template>
  <div class="">
    <div class="">
      <div v-if="staffDetailsLoading">
        <div role="status" class="flex justify-center w-full mt-6">
          <LoadingSpinner />
        </div>
      </div>
      <div v-else>
        <div class="">
          <div class="">
            <div class="p-3">
              <div class="font-semibold text-[#09518C]">Employee Profile</div>
            </div>
            <div
              v-if="staffErrorMsg"
              class="bg-red-600 text-white text-center mb-3 rounded-md py-4"
            >
              <font-awesome-icon class="mr-2" icon="fa-exclamation-triangle" />
              {{ staffErrorMsg }}
            </div>
            <div class="flex flex-col gap-4 md:flex-row">
              <div class="p-3 shadow rounded md:w-1/3">
                <div>
                  <h2 class="font-bold text-[#09518C]">Details</h2>
                </div>
                <div class="md:flex items-center justify-between">
                  <div class="mr-3 mt-1">
                    <p class="text-gray-500 text-sm">
                      {{
                        staffDetails?.first_name + " " + staffDetails?.last_name
                      }}
                    </p>
                    <p class="text-gray-500 text-sm">{{ staffDetails?.pin }}</p>
                  </div>
                  <div class="mt-1 md:mt-0">
                    <span
                      class="text-sm py-1 px-1 bg-[#E3FEEC] rounded-lg text-[#55AB68]"
                    >
                      FUND {{ staffDetails?.fund_type }}
                    </span>
                  </div>
                </div>
              </div>
              <div class="flex items-center p-3 shadow rounded md:w-1/3">
                <div>
                  <h2 class="font-bold text-[#09518C]">Contact</h2>
                  <div class="mt-1 text-sm">
                    <p class="text-gray-500 text-sm">
                      <font-awesome-icon
                        icon="fa-solid fa-phone"
                        class="mr-2"
                      />{{ staffDetails?.mobile }}
                    </p>
                    <p class="text-gray-500 text-xs" v-if="staffDetails?.email">
                      <font-awesome-icon
                        icon="fa-solid fa-envelope"
                        class="mr-2"
                      />{{ staffDetails?.email }}
                    </p>
                    <p class="text-gray-500 text-sm">
                      <font-awesome-icon
                        icon="fa-solid fa-calendar-days"
                        class="mr-2"
                      />{{ staffDetails?.dob?.substring(0, 10) }}
                    </p>
                  </div>
                </div>
              </div>
              <div class="p-3 shadow rounded md:w-1/3">
                <h2 class="font-bold text-[#09518C]">Payment Status</h2>
                <div class="flex items-center">
                  <span class="text-[#8dc63f]">
                    <div
                      class="bg-[#8dc63f] text-white py-1 px-2 w-24 rounded-xl text-sm mr-2"
                    >
                      <div class="text-center">
                        {{ staffDetails?.funding_status }}
                      </div>
                    </div>
                  </span>
                  <div class="py-4 text-sm">
                    <p class="text-gray-600">Last Payment</p>
                    <p>
                      {{ staffDetails?.last_payment_date?.substring(0, 10) }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="mt-4">
      <div>
        <div class="flex flex-col p-4">
          <div class="font-semibold text-[#09518C]">Transaction History</div>
          <div
            v-if="errorMsg"
            class="bg-red-600 text-white text-center mb-3 rounded-md py-4"
          >
            <font-awesome-icon class="mr-2" icon="fa-exclamation-triangle" />
            {{ errorMsg }}
          </div>

          <div>
            <form
              @submit.prevent="getStaffTransactions"
              class="flex flex-col md:flex-row"
            >
              <div class="flex mr-4">
                <div class="">
                  <p class="block text-gray-700 text-sm mb-1">From</p>
                  <div>
                    <Datepicker
                      :enableTimePicker="false"
                      class="appearance-none w-full rounded py-2 text-gray-800 leading-tight focus:outline-none focus:shadow-outline"
                      style="background: none; border: none"
                      v-model="startDate"
                    ></Datepicker>
                  </div>
                </div>
              </div>
              <div class="flex lg:mx-0">
                <div class="">
                  <p class="block text-gray-700 text-sm mb-1">To</p>
                  <div>
                    <Datepicker
                      :enableTimePicker="false"
                      class="appearance-none w-full rounded py-2 text-gray-800 leading-tight focus:outline-none focus:shadow-outline"
                      style="background: none; border: none"
                      v-model="endDate"
                    ></Datepicker>
                  </div>
                </div>
              </div>
              <div class="md:ml-4 mt-2 md:mt-8">
                <button
                  :disabled="staffTransactions.length === 0"
                  class="bg-[#8dc63f] hover:text-[#F58220] hover:bg-white hover:border-[#8DC63F] border transition-colors duration-300 text-white px-4 py-2 rounded-md text-sm"
                >
                  Fetch
                </button>
              </div>
            </form>
          </div>
          <!-- <div class="float-right p-4">
            <p class="text-red-500">{{ error?.message }}</p>
          </div> -->
          <div class="overflow-x-auto" v-if="loading === false">
            <TableComponent
              :columns="tableColumns"
              :data="displayedStaffs"
              :renderCell="customRenderCell"
            />
            <!-- <table class="w-full border">
              <thead>
                <tr class="text-left">
                  <th class="px-4 py-2 w-1/4">Date</th>
                  <th class="px-4 py-2 w-1/4">Employer Contribution</th>
                  <th class="px-4 py-2 w-1/4">Employee Contribution</th>
                  <th class="px-4 py-2 w-1/4">Voluntary Contribution</th>
                </tr>
              </thead>

              <tbody v-if="loading === false">
                <tr
                  class="border-b-2"
                  v-for="item in displayedStaffs"
                  :key="item.id"
                >
                  <td class="px-4 py-2 w-1/4">
                    {{ item?.posting_date.split(" ")[0] }}
                  </td>
                  <td class="px-4 py-2 w-1/4">
                    ₦ {{ item?.employer_contribution }}
                  </td>
                  <td class="px-4 py-2 w-1/4">
                    ₦ {{ item?.employee_contribution }}
                  </td>
                  <td class="px-4 py-2 w-1/4">
                    ₦ {{ item?.avc_contribution }}
                  </td>
                </tr>
              </tbody>
            </table> -->
          </div>

          <div
            class="text-center text-[#8dc63f] my-3"
            v-if="staffTransactions.length === 0 && !loading"
          >
            No Transaction Available for the specified period
          </div>
          <span v-if="loading"><LoadingSpinner /></span>

          <!-- <pagination
            v-model="page"
            :records="staffTransactions.length"
            :per-page="20"
          /> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { computed, onMounted, ref } from "@vue/runtime-core";
import { useRoute } from "vue-router";
import { toolkitAxios } from "@/env";
import LoadingSpinner from "@/components/LoadingSpinner";
import TableComponent from "@/components/TableComponent.vue";
export default {
  components: {
    LoadingSpinner,
    TableComponent,
  },
  setup() {
    const route = useRoute();
    const staffDetails = ref("");
    const pin = ref(route.params.pin);
    const startDate = ref(
      new Date(new Date().setFullYear(new Date().getFullYear() - 1))
    );
    const endDate = ref(new Date());
    const staffTransactions = ref([]);
    const page = ref(1);
    const perPage = ref(20);
    const currentPage = ref(1);
    const loading = ref(false);
    const staffDetailsLoading = ref(false);
    const errorMsg = ref("");
    const staffErrorMsg = ref("");
    const tableColumns = ref([
      { key: "posting_date", label: "Date", className: "px-2 py-2" },
      {
        key: "employer_contribution",
        label: "Employer Contribution(₦)",
        className: "px-2 py-2",
      },
      {
        key: "employee_contribution",
        label: "Employee Contribution(₦)",
        className: "px-2 py-2",
      },
      {
        key: "avc_contribution",
        label: "Voluntary Contribution(₦)",
        className: "px-2 py-2",
      },
    ]);

    const customRenderCell = (item, column) => {
      if (column.key === "posting_date") {
        return item?.posting_date.split(" ")[0];
      }

      return item[column.key];
    };

    const onPageChange = (page) => {
      currentPage.value = page;
    };

    const getStaffDetails = async () => {
      staffDetailsLoading.value = true;
      console.log(staffDetailsLoading.value, "loading");
      await toolkitAxios
        .post("employer/staffs/details", {
          pin: pin.value,
        })
        .then((response) => {
          staffDetails.value = response.data.data;
          staffDetailsLoading.value = false;
        })
        .catch((e) => {
          staffErrorMsg.value = error.response.data.message;
          staffDetailsLoading.value = false;
        });
    };

    const displayedStaffs = computed(() => {
      const startIndex = perPage.value * (page.value - 1);
      const endIndex = startIndex + perPage.value;
      return staffTransactions.value.slice(startIndex, endIndex);
    });

    const getStaffTransactions = async () => {
      loading.value = true;

      await toolkitAxios
        .post("employer/staffs/transactions", {
          pin: pin.value,
          start_date: startDate.value,
          end_date: endDate.value,
        })
        .then((response) => {
          // console.log(response.data.data)
          staffTransactions.value = response.data.data;
          if (errorMsg.value !== "") {
            errorMsg.value = "";
          }
        })
        .catch((error) => {
          errorMsg.value = error.response.data.message;
        });

      loading.value = false;
    };

    onMounted(() => {
      getStaffDetails();
      getStaffTransactions();
    });

    return {
      pin,
      route,
      page,
      getStaffDetails,
      staffDetails,
      startDate,
      endDate,
      getStaffTransactions,
      staffTransactions,
      displayedStaffs,
      perPage,
      onPageChange,
      currentPage,
      loading,
      errorMsg,
      tableColumns,
      customRenderCell,
      staffDetailsLoading,
      staffErrorMsg,
    };
  },
};
</script>
